export const selectPersonalTask = (id)=>({ personalTasks })=>personalTasks.data.find((d)=>d.personalTaskId === id);
export const selectPersonalTasks = (state)=>state.personalTasks;
